import { FC, useEffect, useState } from 'react';
import { Redirect } from 'react-router';
import { useActiveClientContext } from 'store/active-client';
import { usePermissionsContext } from 'store/permissions';
import { PermissionKeys } from 'store/types';
import { buildClientUrl } from 'utils/helpers/client';

const HomeScreen: FC = () => {
  const { client } = useActiveClientContext();
  const { permissions, checkPermission } = usePermissionsContext();
  const [isClientEmployee, setIsClientEmployee] = useState(checkPermission(PermissionKeys.CAN_SEE_EMPLOYEE_NAV));

  useEffect(() => {
    setIsClientEmployee(checkPermission(PermissionKeys.CAN_SEE_EMPLOYEE_NAV));
  }, [permissions]);

  /**
   * Redirect to `/documents/received` if client admin or operator
   * and to `/my-documents/received` if client employee
   */
  const redirectUri = isClientEmployee ? '/my-documents/received' : '/documents/received';

  return <Redirect to={buildClientUrl(redirectUri, client)} />;
};

export default HomeScreen;
